/** @format */

import { Component, inject, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { WINDOW } from '@shared/data-access/services';
import { EvergreenTemplateData } from '../google-ad-manager/google-ad-manager.interface';
import { CDN_BASE_URL } from '../google-ad-manager/google-ad-manager.constants';

@Component({
  selector: 'shared-components-evergreen-template',
  templateUrl: './evergreen-template.component.html',
  styleUrl: './evergreen-template.component.scss',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EvergreenTemplateComponent {
  readonly templateData = input<EvergreenTemplateData | null>(null);
  readonly isNarrowTemplate = input<boolean>(false);
  readonly pageType = input<string>('');

  protected readonly imageLoaded = signal<boolean>(false);

  private readonly window = inject(WINDOW);

  onClick(): void {
    const data = this.templateData();
    if (data?.CTA_URL) {
      const target = data.CTA_TAB_BEHAVIOR || '_blank';
      this.window.open(data.CTA_URL, target);
    }
  }

  onImageLoaded(event: Event): void {
    // when not using SSR, remove the skeleton loader when the img is loaded from our CDN
    const img = event.target as HTMLImageElement;
    if (img?.currentSrc.includes(CDN_BASE_URL)) {
      this.imageLoaded.set(true);
    }
  }
}
